// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"9a0df935","584":"f346c03c"}[chunkId] + ".chunk.css";
};